import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type { Documento, CreateDocumentoInput } from '../types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export function useCreateDocumento() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateDocumentoInput) =>
      api.post<Documento>('/documenti', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useDeleteDocumento() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; projectId: string }) =>
      api.delete(`/documenti/${id}`),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

/**
 * Scarica un documento passando dall'endpoint protetto (Authorization: Bearer),
 * quindi non è possibile usare un semplice <a href>. Recupera il blob e forza
 * il download lato browser.
 */
export async function downloadDocumento(id: string, originalName: string): Promise<void> {
  const token = api.getAccessToken();
  const response = await fetch(`${API_URL}/documenti/${id}/download`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error('Download non riuscito');
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = originalName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
